import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import Modal from '@mui/material/Modal';
import Chip from '@mui/material/Chip';

import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    Box,
    Tooltip
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // ícone para "Ordem de Compra"
import PaymentIcon from "@mui/icons-material/Payment"; // ícone de pagamento

import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography } from '@mui/material';
import { Card, CardContent } from '@mui/material';

import { format, isValid, parse } from 'date-fns';
import { useHistory } from "react-router-dom";


import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';

import RequestQuoteIcon from '@mui/icons-material/Calculate';

export default function CadastrarLancamento() {
    const history = useHistory();

    const location = useLocation();
    const [openDadosPagamento, setOpenDadosPagamento] = useState(false);

    const { projetoCad, propostaCad, flagBack, flagPath } = location.state || {};

    // Recebe parâmetros opcionais da URL
    const queryParams = new URLSearchParams(location.search);
    const idprecotacao = queryParams.get("idprecotacao"); // retorna string ou null se não existir


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });


    const [estadoBotaoSalvar, setEstadoBotaoSalvar] = useState(false);
    const [loading, setLoading] = useState(true);


    const [tipo, setTipo] = useState(0);
    const today = new Date();

    // Formata a data de hoje para dd/mm/yyyy
    const formattedDate = format(today, 'dd/MM/yyyy');
    const [data, setData] = useState();
    const [dataLancamento, setDataLancamento] = useState(formattedDate);

    const [centroCusto, setCentroCusto] = useState(null);
    const [fornecedor, setFornecedor] = useState(null);
    const [conta, setConta] = useState(null);
    const [contas, setContas] = useState([]);

    const [centrosCusto, setCentrosCusto] = useState([]);

    const [fornecedores, setFornecedores] = useState([]);
    const [observacao, setObservacao] = useState('');
    const [descricao, setDescricao] = useState('');
    const [identificacao, setIdentificacao] = useState('');
    const [clientes, setClientes] = useState([]);

    const [cliente, setCliente] = useState(null);


    const handleChangeTipo = (event) => {
        setTipo(event.target.value);
    };



    async function salvar() {
        try {


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }
            var id_user = Cookies.get('id_usuario');

            const parsedDate = parse(dataLancamento, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data do Lançamento é invalida!");
                return;
            }

            const dataFormatada = format(parse(dataLancamento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');

            if (!conta) {
                alert("selecione a Conta");
                return;
            }

            const cadastro = {

                tipo: tipo,
                usuario_criador: { id_usuario: id_user, },
                data_lancamento: dataFormatada,
                conta: conta,
                descricao: descricao,
                observacao: observacao,
                identificacao: identificacao,
                identificador: identificador,



            };

            if (idprecotacao) {
                cadastro.id_pre_cotacao = idprecotacao;
                cadastro.id_ordem_compra = preCotacao.id_ordem_compra;
                cadastro.valor = preCotacao.valor_total;

                const response2 = await api.get('/v1/protected/financeiro/lancamentos/listarporprecotacao/' + idprecotacao,
                    { headers: headers });

                if (parseInt(response2.data, 10) > 0) {
                    alert("O lançamento ID " + response2.data + " criado está associado a esta Pré-Cotação!");
                    return;
                }

            }

            if (parseInt(flagBack, 10) === 11) {
                cadastro.id_proposta = propostaCad.id_proposta;
            }

            if (tipo === 0) {
                //despesa
                if (!centroCusto) {
                    alert("selecione a Centro de Custo pagador");
                    return;
                } else {
                    cadastro.centro_custo = centroCusto
                }

                if (!fornecedor) {
                    alert("selecione o Fornecedor recebedor");
                    return;
                } else {
                    cadastro.fornecedor = fornecedor
                }
            } else if (tipo === 1) {
                //receita
                if (!centroCusto) {
                    alert("selecione a Centro de Custo recebedor");
                    return;
                } else {
                    cadastro.centro_custo = centroCusto
                }

                if (!cliente) {
                    alert("selecione o Cliente pagador");
                    return;
                } else {
                    cadastro.cliente = cliente
                }
            }




            const response = await api.post('/v1/protected/financeiro/lancamentos/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                if (parseInt(flagBack, 10) === 11) {
                    history.push({
                        pathname: flagPath,
                    })
                } else {
                    history.push({
                        pathname: "/gestao/financas/lancamento/gerenciar/" + cadastro_salvo.id_lancamento,
                    })
                }




            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }

    };

    const [projetos, setProjetos] = useState([]);
    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);
    const [preCotacao, setPreCotacao] = useState([]);

    const [controlTipoLancamento, setControlTipoLancamento] = useState(false);

    const [identificador, setIdentificador] = useState("");



    const handleAbrirProjeto = (id_ordem_compra) => {
        console.log("Abrir Projeto");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + id_ordem_compra,
            "_blank" // abre em nova aba
        );
    };

    const handleAbrirOrdemCompra = (id_ordem_compra) => {
        console.log("Abrir Ordem de Compra");
        window.open(
            "/gestao/administracao/ordensdecompras/editar/" + id_ordem_compra,
            "_blank" // abre em nova aba
        );
    };


    function returnDescricaoMetodoPagamento(metodo) {
        var texto = "Nome: " + metodo.nome +
            " | Codigo: " + metodo.codigo + " | Sigla: " + metodo.sigla + "\nDescrição: " + metodo.descricao;
        return texto;
    }


    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "Banco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }

    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/financeiro/contas/listartodos", {
                headers: headers
            }).then(function (response) {
                setContas(response.data)

                if (idprecotacao) {

                    setControlTipoLancamento(true);

                    api.get("v1/protected/financeiro/centrocusto/listartodos", {
                        headers: headers
                    }).then(function (response) {

                        setCentrosCusto(response.data);


                    });

                    api.get("v1/protected/ordensdecompras/ordemdecompra/precotacao/listarporid/" + idprecotacao, {
                        headers: headers
                    }).then(function (response) {

                        if (response.data.id_lancamento) {
                            if (response.data.id_lancamento > 0)
                                history.push({
                                    pathname: "/gestao/financas/lancamento/gerenciar/" + response.data.id_lancamento,
                                })
                        }

                        setPreCotacao(response.data);
                        setFornecedor(response.data.fornecedor);
                        setIdentificacao(
                            "Pré-Cotação " + response.data.id_ordem_compra + "." + response.data.id_pre_cotacao
                        );
                        setIdentificador("O.C " + response.data.id_ordem_compra + "." + response.data.id_pre_cotacao);

                        setLoading(false);


                    });
                } else {

                    if (parseInt(flagBack, 10) === 11) {
                        // alert("Cadastrar Por Proposta!");
                        setProjetos([]);
                        setProjetoSelecionado(projetoCad);
                        setPropostaSelecionada(propostaCad);

                    }

                    api.get("v1/protected/fornecedores/listarTodos", {

                        headers: headers
                    }).then(function (response) {


                        setFornecedores(response.data);
                        api.get("v1/protected/financeiro/centrocusto/listartodos", {
                            headers: headers
                        }).then(function (response) {

                            setCentrosCusto(response.data);
                            setLoading(false);


                            api.get("v1/protected/clientes/listarTodos", {
                                headers: headers
                            }).then(function (response) {

                                setClientes(response.data);


                            });

                        });




                    });


                }


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }






    function returnDescricaoFornecedor(fornecedor) {

        var identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF " : "CNPJ"

        var valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

        var nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
            (fornecedor.nome_fantasia);

        var endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;


        var texto = "ID: " + fornecedor.id_fornecedor + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + endereco;
        return texto;
    }


    function returnDescricaoCentroCusto(cc) {
        var texto = cc.nome;
        return texto;
    }

    function returnDescricaoConta(conta) {
        var texto = conta.grupo_contas.nome + "\n" + conta.nome + "\nDescrição: " + conta.descricao;
        return texto;
    }

    function returnDescricaoCliente(cliente) {

        var identificacao = cliente.tipo_cliente === 0 ? "CPF " : "CNPJ"

        var valor = cliente.tipo_cliente === 0 ? cliente.cpf : cliente.cnpj;

        var nome = cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) :
            (cliente.nome_fantasia);

        var endereco = cliente.logradouro + ", nº " + cliente.numero + ", " + cliente.bairro + ", " + cliente.cidade + " " + cliente.estado + " CEP: " + cliente.cep;


        var texto = "ID: " + cliente.id_cliente + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + endereco;
        return texto;
    }


    useEffect(() => {

        listarInformacoes();


    }, []);


    function returnDescricaoProjeto(projeto) {
        var texto = projeto.id_projeto + " - " + projeto.descricao_projeto + "\n";//+ returnDescricaoInstalacao(projeto.instalacao);
        return texto;
    }


    function returnDescricaoProposta(proposta) {
        var texto = proposta.id_proposta + " - " + proposta.descricao_proposta;
        return texto;
    }


    function handleSetProjeto(projeto) {
        setProjetoSelecionado(projeto);
    }


    function handleSetProposta(proposta) {
        setPropostaSelecionada(proposta);
    }


    return (
        <div>
            <NavegadorGestao
                Financas={true}
                TabelasAuxiliaresFinancas={true}
                InstituicaoBancaria={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />
            {!loading &&
                <Grid

                    container
                    direction="row"
                    item xs={12}
                    alignItems="center"
                    justifyContent="center"
                    style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                >

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        <Button style={{ margin: 5 }}
                            variant="contained"
                            color="primary"
                            onClick={salvar}
                        > Salvar </Button>
                    </Grid>

                    <Grid
                        item xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        style={{ padding: 10 }}
                        container  >



                        {parseInt(flagBack, 10) === 11 &&
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 1 }}
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    align="flex-end"
                                    item xs={6}
                                    style={{ marginTop: 1 }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={8}
                                    >

                                        <Autocomplete
                                            id="select-projeto"
                                            options={projetos}
                                            disabled={true}
                                            getOptionLabel={(projeto) => returnDescricaoProjeto(projeto).replace(/<br \/>/g, '\n')}
                                            value={projetoSelecionado}
                                            onChange={(e, v) => handleSetProjeto(v)}
                                            filterOptions={(options, { inputValue }) => {
                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                return options.filter((cotacao) => {
                                                    const cotacaoText = returnDescricaoProjeto(cotacao).toLowerCase();
                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label=" Projeto " multiline minRows={3} />
                                            )}
                                            renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoProjeto(option) }} />
                                            )}
                                        />
                                    </Grid>
                                </Grid>




                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    align="flex-start"
                                    item xs={6}
                                    style={{ marginTop: 1 }}
                                >
                                    {
                                        projetoSelecionado &&
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={8}
                                        >

                                            <Autocomplete
                                                disabled={true}
                                                id="select-proposta"
                                                options={projetoSelecionado.propostas}
                                                getOptionLabel={(proposta) => returnDescricaoProposta(proposta).replace(/<br \/>/g, '\n')}
                                                value={propostaSelecionada}
                                                onChange={(e, v) => handleSetProposta(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((cotacao) => {
                                                        const cotacaoText = returnDescricaoProposta(cotacao).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label=" Proposta " multiline minRows={3} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoProposta(option) }} />
                                                )}
                                            />
                                        </Grid>
                                    }
                                </Grid>



                            </Grid>
                        }


                        <Grid item xs={3} style={{ padding: 2 }}>
                            <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                <CardContent>
                                    <Grid
                                        item xs={12}
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                        style={{ padding: 2 }}
                                        container  >


                                        <Grid
                                            item xs={12}
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            style={{ padding: 10 }}
                                            container
                                        >
                                            <Grid item xs={12}
                                                container
                                                alignItems="center"
                                                justifyContent="center"
                                            >
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="tipo_notificacao_registro-label">Tipo do Lançamento</InputLabel>
                                                        <Select
                                                            labelId="tipo_notificacao_registro-label"
                                                            id="area-tipo_registro"
                                                            value={tipo}
                                                            onChange={handleChangeTipo}
                                                            label="Tipo do Lançamento"
                                                            disabled={controlTipoLancamento}
                                                        >
                                                            <MenuItem value={0}>Despesa</MenuItem>
                                                            <MenuItem value={1}>Receita</MenuItem>


                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>


                                        </Grid>




                                        <Grid
                                            item xs={12}
                                            alignItems="flex-start"
                                            justifyContent="flex-start"
                                            style={{ padding: 10 }}
                                            container
                                        >

                                            <TextField
                                                variant="standard"
                                                name="dataLancamento"
                                                label="Data Lançamento"
                                                required
                                                id="dataLancamento"
                                                value={dataLancamento}
                                                onChange={(e) => setDataLancamento(e.target.value)}
                                                fullWidth
                                            />

                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>


                        {tipo === 0 &&
                            <Grid item xs={5} style={{ padding: 2 }}>
                                <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                    <CardContent>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 10 }}
                                            >

                                                <Autocomplete
                                                    id="select-centro-custo"
                                                    options={centrosCusto}
                                                    getOptionLabel={(centroCusto) => returnDescricaoCentroCusto(centroCusto).replace(/<br \/>/g, '\n')}
                                                    value={centroCusto}
                                                    onChange={(e, v) => setCentroCusto(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((centroCusto) => {
                                                            const cotacaoText = returnDescricaoCentroCusto(centroCusto).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pagador: Centro de Custo" multiline minRows={2} fullWidth />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoCentroCusto(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 10 }}
                                            >

                                                <Autocomplete
                                                    id="select-fornecedor_cotacao1"
                                                    options={idprecotacao ? [] : fornecedores}

                                                    getOptionLabel={(fornecedor) => returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, '\n')}
                                                    value={fornecedor}
                                                    onChange={(e, v) => setFornecedor(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((fornecedor) => {
                                                            const cotacaoText = returnDescricaoFornecedor(fornecedor).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Recebedor: Fornecedor" multiline minRows={2} fullWidth />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoFornecedor(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        }


                        {tipo === 1 &&

                            <Grid item xs={5} style={{ padding: 2 }}>
                                <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                    <CardContent>


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 10 }}
                                            >

                                                <Autocomplete
                                                    id="select-fornecedor_cotacao1"
                                                    options={clientes}

                                                    getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
                                                    value={cliente}
                                                    onChange={(e, v) => setCliente(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((cliente) => {
                                                            const cotacaoText = returnDescricaoCliente(cliente).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pagador: Cliente" multiline minRows={2} fullWidth />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>



                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                        >
                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 10 }}
                                            >

                                                <Autocomplete
                                                    id="select-centro-custo"
                                                    options={centrosCusto}
                                                    getOptionLabel={(centroCusto) => returnDescricaoCentroCusto(centroCusto).replace(/<br \/>/g, '\n')}
                                                    value={centroCusto}
                                                    onChange={(e, v) => setCentroCusto(v)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((centroCusto) => {
                                                            const cotacaoText = returnDescricaoCentroCusto(centroCusto).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Recebedor: Centro de Custo" multiline minRows={2} fullWidth />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoCentroCusto(option) }} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>



                                    </CardContent>
                                </Card>
                            </Grid>
                        }


                        <Grid item xs={4} style={{ padding: 2 }}>
                            <Card style={{ marginBottom: '10px', borderRadius: '8px', border: '1px solid gray' }}>
                                <CardContent>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                    >
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                            style={{ padding: 10 }}
                                        >
                                            <Autocomplete
                                                id="select-conta"
                                                options={contas}
                                                getOptionLabel={(conta) => returnDescricaoConta(conta).replace(/<br \/>/g, '\n')}
                                                value={conta}
                                                onChange={(e, v) => setConta(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((conta) => {
                                                        const cotacaoText = returnDescricaoConta(conta).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Conta" multiline minRows={2} fullWidth />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoConta(option) }} />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>


                                    <Grid
                                        item xs={12}
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                        style={{ padding: 15 }}
                                        container
                                    >

                                        <Typography variant="body1" style={{ fontSize: 18 }}>
                                            Valor: <strong>{currencyFormatter.format(preCotacao?.valor_total ?? 0.0)}</strong>
                                        </Typography>

                                    </Grid>

                                    {preCotacao && (
                                        <Tooltip
                                            title="Clique para ver dados de pagamento"
                                            placement="left"
                                            arrow
                                        >
                                            <IconButton
                                                size="small"
                                                style={{ marginLeft: 8 }}
                                                onClick={() => setOpenDadosPagamento(true)}
                                            >
                                                <PaymentIcon color="primary" fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                </CardContent>
                            </Card>
                        </Grid>


                    </Grid>



                    <Grid
                        item xs={12}
                        alignItems="center"
                        justifyContent="center"
                        style={{ padding: 2 }}
                        container
                    >


                        <Grid
                            item xs={6}
                            alignItems="center"
                            justifyContent="center"
                            style={{ padding: 2 }}
                            container
                        >

                            <Grid
                                item xs={6}
                                alignItems="center"
                                justifyContent="center"
                                container
                            >
                                <TextField
                                    variant="standard"
                                    name="identificacao"
                                    label="Identificação"
                                    required
                                    id="identificacao"
                                    value={identificacao}
                                    onChange={(e) => setIdentificacao(e.target.value)}
                                    disabled={idprecotacao ? true : false}
                                    fullWidth
                                />

                            </Grid>
                            <Grid
                                item xs={1}
                                alignItems="center"
                                justifyContent="center"
                                container
                            >
                                {idprecotacao && (
                                    <Tooltip title="Clique para Abrir a Pré-Cotação" arrow>
                                        <IconButton
                                            onClick={() => {
                                                const link =
                                                    "/gestao/administracao/ordensdecompras/editar/" +
                                                    preCotacao.id_ordem_compra +
                                                    "/editarcotacao/" +
                                                    idprecotacao;
                                                window.open(link, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <RequestQuoteIcon style={{ color: 'black' }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Grid>
                            <Grid
                                item xs={2}
                                alignItems="center"
                                justifyContent="center"
                                container
                            >
                                {idprecotacao && (
                                    <Tooltip title="Clique para acessar a Ordem de Compra autorizada" arrow>
                                        <div
                                            onClick={() => {
                                                const link = preCotacao.caminho_arquivo.replaceAll(
                                                    "/home/wwgrup/ordensdecompra/",
                                                    "https://gruporosinetos.com/ocmidias/"
                                                );
                                                window.open(link, "_blank", "noopener,noreferrer");
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: 0,
                                                width: "40px",
                                                height: "40px",
                                            }}
                                        >
                                            <img
                                                alt="miniatura_pdf"
                                                style={{ textAlign: "center" }}
                                                src={miniatura_pdf}
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                            </Grid>



                        </Grid>

                        <Grid
                            item xs={6}
                            alignItems="center"
                            justifyContent="center"
                            style={{ padding: 2 }}
                            container
                        >

                            <TextField
                                variant="standard"
                                name="descricao"
                                label="Descrição"
                                required
                                id="descricao"
                                value={descricao}
                                fullWidth
                                multiline
                                minRows={1}
                                onChange={(e) => setDescricao(e.target.value)}
                            />
                        </Grid>


                    </Grid>

                    <Grid
                        container
                        item
                        xs={12}
                        alignItems="center"
                        justifyContent="center"
                        style={{ padding: 10 }}
                    >
                        <Grid item xs={3} />

                        <Grid item xs={3} style={{ textAlign: "center" }}>

                        </Grid>

                        <Grid item xs={3} style={{ textAlign: "center" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<ReceiptLongIcon />}
                                onClick={(e) => handleAbrirOrdemCompra(preCotacao.id_ordem_compra)}
                                disabled={preCotacao.id_ordem_compra ? false : true}

                            >
                                Ordem de Compra
                            </Button>
                        </Grid>

                        <Grid item xs={3} />
                    </Grid>



                    <Grid
                        item xs={12}
                        alignItems="flex-start"
                        justifyContent="flex-start"
                        style={{ padding: 10 }}
                        container
                    >
                        <Grid
                            item xs={12}
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            style={{ padding: 10 }}
                            container
                        >
                            <TextField
                                variant="standard"
                                name="observacao"
                                label="Observações"
                                required
                                id="observacao"
                                value={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                                fullWidth
                                multiline
                                minRows={1}
                            />
                        </Grid>
                    </Grid>





                </Grid>
            }




            <Modal
                open={openDadosPagamento}
                onClose={() => setOpenDadosPagamento(false)}
                aria-labelledby="atributos-financeiros"
            >
                {preCotacao ?
                    (<Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "white",
                            height: "70vh",
                            width: "70vw",
                            overflow: "auto",
                            border: "2px solid black",
                            boxShadow: 24,
                            p: 2,
                        }}
                    >

                        <Typography variant="h6" style={{ marginTop: 5 }}>
                            Atributos Financeiros
                        </Typography>

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                            style={{ marginTop: 5 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={6}
                            >

                                <Autocomplete
                                    id="select-metodos-pagamento"
                                    options={[]}
                                    disableCloseOnSelect
                                    multiple
                                    fullWidth
                                    getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                    value={preCotacao.metodos_pagamento}
                                    filterOptions={(options, { inputValue }) => {
                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                        return options.filter((solicitante) => {
                                            const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Metodos de Pagamento " multiline rows={2} />
                                    )}
                                    renderOption={(option) => (
                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((metodo, index) => (
                                            <Chip
                                                label={returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                                {...getTagProps({ index })}
                                             />
                                        ))
                                    }
                                />
                            </Grid>
                        </Grid>


                        <Box
                            sx={{
                                maxWidth: 900,
                                mx: "auto", // centraliza horizontalmente
                                p: 3,
                                mt: 4,
                                border: "1px solid #ccc",
                                borderRadius: 2,
                                boxShadow: 3,
                                backgroundColor: "#f9f9f9",
                            }}
                        >
                            <Typography variant="h6" align="center" gutterBottom>
                                Condições de Pagamento
                            </Typography>

                            <Grid container spacing={2}>
                                {/* Modalidade */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Modalidade</InputLabel>
                                        <Select
                                            value={preCotacao.condicao_pagamento}
                                        >
                                            <MenuItem value={0}>Antecipado - À vista</MenuItem>
                                            <MenuItem value={1}>Após receber Nota Fiscal</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Tipo do Intervalo */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Tipo do Intervalo</InputLabel>
                                        <Select
                                            value={preCotacao.tipo_intervalo}

                                        >
                                            <MenuItem value={0}>Fixo</MenuItem>
                                            <MenuItem value={1}>Variável</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Número de Parcelas */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nº de Parcelas"
                                        value={preCotacao.numero_parcelas}
                                    />
                                </Grid>

                                {/* Intervalo de Parcelas */}
                                {preCotacao.tipo_intervalo === 0 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Intervalo (dias)"
                                            value={preCotacao.intervalo_parcelas}
                                        />
                                    </Grid>
                                )}
                                {preCotacao.tipo_intervalo === 1 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Intervalo Variável (dias)"
                                            value={preCotacao.intervalo_variavel}
                                        />
                                    </Grid>
                                )}

                                {/* Intervalo da Primeira Parcela */}
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Primeira Parcela (dias)"
                                        value={preCotacao.intervalo_primeira_parcela}
                                    />
                                </Grid>

                                {/* Tipo de Divisão */}
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Tipo de Divisão</InputLabel>
                                        <Select
                                            value={preCotacao.tipo_divisao}
                                        >
                                            <MenuItem value={0}>Igualitária</MenuItem>
                                            <MenuItem value={1}>Variável</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Divisão Variável */}
                                {preCotacao.tipo_divisao === 1 && (
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Divisão (%)"
                                            value={preCotacao.divisao_variavel}
                                        />
                                    </Grid>
                                )}
                            </Grid>

                            {/* contabancaria */}
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={6}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12}
                                >


                                    <Autocomplete
                                        id="select-fornecedor-recebedor"
                                        options={[]}
                                        fullWidth
                                        style={{ fontSize: '14px' }}
                                        getOptionLabel={(conta) => returnDescricaoBanco(conta).replace(/<br \/>/g, '\n')}
                                        value={preCotacao.conta_bancaria}
                                        getOptionSelected={(option, value) => option.id_conta_bancaria === value?.id_conta_bancaria}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((solicitante) => {
                                                const cotacaoText = returnDescricaoBanco(solicitante).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                style={{ fontSize: '14px' }}
                                                InputProps={{ ...params.InputProps, style: { fontSize: '14px' } }}
                                                InputLabelProps={{ style: { fontSize: '14px' } }}
                                                label=" Conta Bancária do Recebedor "
                                                multiline
                                                minRows={2}
                                            />
                                        )}
                                    />




                                </Grid>
                            </Grid>

                        </Box>


                    </Box>
                    ) :
                    (
                        <div /> // placeholder vazio
                    )
                }


            </Modal>

        </div >
    );
}


